import { SORTING_DIR } from "@/common/models";
import { ITableConfig } from "@/components/table/table.model";

// file name, information type , context , topic , sensitivity , source , details
/* export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "File Name",
      key: "name",
      spanMin: "20rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      jsPath: "data.items[].name",
    },
    {
      name: "Information type",
      key: "information",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "data.items[].labels.infoLabel.name",
    },
    {
      name: "PIIs",
      key: "piis",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "data.items[].labels.piis[*].name",
    },
    {
      name: "Context",
      key: "context",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "data.items[].labels.ctxLabels[*].name",
    },
    {
      name: "Sensitivity",
      key: "sensitivity",
      spanMin: "8rem",
      spanMax: "8rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "data.items[].sensitivity",
    },
    {
      name: "Application",
      key: "source",
      spanMin: "8rem",
      spanMax: "8rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "data.items[].sourceApplication",
    },
    {
      name: "Details",
      key: "details",
      spanMin: "12rem",
      spanMax: "12rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
    {
      name: "",
      key: "summary",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
  ],
};
 */

export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "File Name / Email",
      key: "name",
      spanMin: "20rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      jsPath: "data.items[].name",
    },
    {
      name: "Information type",
      key: "information",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "data.items[].labels.infoLabel.name",
    },
    {
      name: "PIIs",
      key: "piis",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "data.items[].labels.piis[*].name",
    },
    {
      name: "Sensitivity",
      key: "sensitivity",
      spanMin: "8rem",
      spanMax: "8rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "data.items[].sensitivityLevel",
    },
    {
      name: "Application",
      key: "source",
      spanMin: "8rem",
      spanMax: "8rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "data.items[].sourceApplication",
    },
    {
      name: "Details/Path",
      key: "details",
      spanMin: "12rem",
      spanMax: "12rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "data.items[].path",
    },
    {
      name: "",
      key: "summary",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
  ],
};
